class OurKit extends HTMLElement {
  constructor() {
    super();
    this.onOpen = this.onOpen.bind(this);
    this.onClose = this.onClose.bind(this);
    this.onOverlayClick = this.onOverlayClick.bind(this);
    this.onKeydown = this.onKeydown.bind(this);
    this.isClosing = false;
    this.closeTimer = null;
  }

  connectedCallback() {
    this.openButton = this.querySelector('[data-our-kit-open]');
    this.overlay = this.querySelector('[data-our-kit-overlay]');
    this.dialog = this.querySelector('[role="dialog"]');
    this.closeButtons = this.querySelectorAll('[data-our-kit-close]');

    if (this.overlay && this.overlay.parentElement !== document.body) {
      document.body.appendChild(this.overlay);
    }

    this.openButton?.addEventListener('click', this.onOpen);
    this.closeButtons.forEach((button) => button.addEventListener('click', this.onClose));
    this.overlay?.addEventListener('click', this.onOverlayClick);
  }

  disconnectedCallback() {
    this.openButton?.removeEventListener('click', this.onOpen);
    this.closeButtons?.forEach((button) => button.removeEventListener('click', this.onClose));
    this.overlay?.removeEventListener('click', this.onOverlayClick);
    document.removeEventListener('keydown', this.onKeydown);
    window.clearTimeout(this.closeTimer);
    document.body.classList.remove('sd-our-kit--open');
    this.overlay?.remove();
  }

  onOpen() {
    if (!this.overlay || this.isClosing) return;

    window.clearTimeout(this.closeTimer);
    this.overlay.hidden = false;
    document.body.classList.add('sd-our-kit--open');
    document.addEventListener('keydown', this.onKeydown);

    requestAnimationFrame(() => {
      this.overlay.classList.add('is-open');
    });

    this.closeButtons[0]?.focus();
  }

  onClose() {
    if (!this.overlay || this.overlay.hidden || this.isClosing) return;

    this.isClosing = true;
    this.overlay.classList.remove('is-open');
    document.removeEventListener('keydown', this.onKeydown);

    this.closeTimer = window.setTimeout(() => {
      this.overlay.hidden = true;
      this.isClosing = false;
      document.body.classList.remove('sd-our-kit--open');
      this.openButton?.focus();
    }, 350);
  }

  onOverlayClick(event) {
    if (event.target === this.overlay) {
      this.onClose();
    }
  }

  onKeydown(event) {
    if (event.key === 'Escape') {
      this.onClose();
    }
  }
}

if (!customElements.get('sd-our-kit')) {
  customElements.define('sd-our-kit', OurKit);
}
